import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn";

export type BadgeTone = "default" | "neutral" | "info" | "success" | "warning" | "danger";
export type BadgeVariant = "solid" | "subtle";

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone;
  variant?: BadgeVariant;
};

export function Badge({
  className,
  tone = "default",
  variant = "solid",
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn("cf-badge", `cf-badge-${tone}`, `cf-badge-${variant}`, className)}
      data-tone={tone === "default" ? "neutral" : tone}
      data-variant={variant}
      {...props}
    >
      {children}
    </span>
  );
}
